import { render } from "./SplitActionDropdown.vue?vue&type=template&id=4bf7979a"
import script from "./SplitActionDropdown.vue?vue&type=script&lang=js"
export * from "./SplitActionDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__